import React, { useContext } from "react";
import Box from "@mui/material/Box";
import classNames from "classnames";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";

import { ConfiguracionContext } from "../../../../context/ConfiguracionContext";
import MaestroArchivo from "../../common/MaestroArchivo";

const colorClase = (n) =>
  classNames({
    rojo: n === "ROJO",
    amarillo: n === "AMARILLO",
    verde: n === "VERDE",
    azul: n === "AZUL",
    fuccia: n === "FUCCIA",
    naranja: n === "NARANJA",
    blanco: n === "BLANCO",
    negro: n === "NEGRO",
    celeste: n === "CELESTE",
    marron: n === "MARRON",
  });

const columns = [
  { field: "id", header: "ID", width: "6rem" },
  {
    field: "nombre",
    header: "Color",
    width: "9rem",
    render: (row) => (
      <Box
        component="span"
        className={colorClase(row.nombre)}
        sx={{ px: 1, py: 0.25, borderRadius: 1, display: "inline-block", fontSize: 12 }}
      >
        {row.nombre}
      </Box>
    ),
  },
  { field: "demoraLlegada", header: "Demora Llegadas" },
  { field: "alertaLlegada", header: "Alerta Llegadas" },
  { field: "demoraSalida", header: "Demora Salidas" },
  { field: "alertaSalida", header: "Alerta Salidas" },
  { field: "alertaPendiente", header: "Alerta Pendientes", type: "bool" },
  { field: "espera", header: "Tiempo en Llegada"},
  { field: "medico", header: "Médico", type: "bool" },
  { field: "chofer", header: "Chofer", type: "bool" },
  { field: "enfermero", header: "Enfermero", type: "bool" },
  { field: "simultaneo", header: "Simultáneo", type: "bool" },
];

const exportColumns = [
  { title: "ID", dataKey: "id" },
  { title: "Color", dataKey: "nombre" },
  { title: "Demora Llegada", dataKey: "demoraLlegada" },
  { title: "Alerta Llegada", dataKey: "alertaLlegada" },
  { title: "Demora Salida", dataKey: "demoraSalida" },
  { title: "Alerta Salida", dataKey: "alertaSalida" },
  { title: "T. Llegada", dataKey: "espera" },
  { title: "Médico", dataKey: "medico" },
  { title: "Chofer", dataKey: "chofer" },
  { title: "Enfermero", dataKey: "enfermero" },
];

const fields = [
  { name: "nombre", label: "Color", type: "text", required: true, disabled: true, md: 12 },
  { name: "demoraLlegada", label: "Demora de llegadas en minutos", type: "number", entero: true, md: 6 },
  { name: "alertaLlegada", label: "Alerta de llegadas en minutos", type: "number", entero: true, md: 6 },
  { name: "demoraSalida", label: "Demora de salidas en minutos", type: "number", entero: true, md: 6 },
  { name: "alertaSalida", label: "Alerta de salidas en minutos", type: "number", entero: true, md: 6 },
  { name: "espera", label: "Tiempo en llegada", type: "number", entero: true, md: 6 },
  { type: "heading", label: "Tripulación necesaria" },
  { name: "medico", label: "Médico", type: "switch", md: 4 },
  { name: "chofer", label: "Chofer", type: "switch", md: 4 },
  { name: "enfermero", label: "Enfermero", type: "switch", md: 4 },
  { name: "simultaneo", label: "Simultáneo", type: "switch", md: 4 },
  { name: "alertaPendiente", label: "Alerta Pendiente", type: "switch", md: 4 },
];

// Campos numéricos vacíos se guardan como 0 (el backend no acepta null)
const camposNumericos = fields
  .filter((f) => f.type === "number")
  .map((f) => f.name);

const vaciosACero = (data) => {
  const copia = { ...data };
  camposNumericos.forEach((campo) => {
    if (copia[campo] === null || copia[campo] === undefined || copia[campo] === "") {
      copia[campo] = 0;
    }
  });
  return copia;
};

export default function Colores() {
  const { colores, obtenerColores, actualizarColor } =
    useContext(ConfiguracionContext);

  return (
    <MaestroArchivo
      titulo="Colores"
      entidad="color"
      layout="Colores"
      icono={<PaletteOutlinedIcon />}
      items={colores}
      permiteNuevo={false}
      columns={columns}
      fields={fields}
      exportColumns={exportColumns}
      onObtener={() => obtenerColores()}
      onAgregar={() => {}}
      onActualizar={(data) => actualizarColor({ color: vaciosACero(data) })}
    />
  );
}
